import nodeMarquee from 'node-marquee';
import { isVisible } from './../../../utilities/js/helper';

class ProductClaims {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-productclaims'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$productClaims = $element;
        this.$claimsWrapper = this.$productClaims.querySelector(`[${this.settings.initAttr}="items"]`);
        this.playing = false;

        this.eventScroller = window.eventScroller;

        if (window.allowAnimation === true) {
            this.initialize();
        }
    }

    initialize () {
        this.initClaimsAnimation();

        this.checkPagePosition();
        this.eventScroller.customFunctions.push(() => {
            this.checkPagePosition();
        });
    }

    checkPagePosition () {
        if (isVisible(this.$claimsWrapper)) {
            if (this.playing === false) {
                this.marquee.play();
                this.playing = true;
            }
        } else {
            if (this.playing === true) {
                this.marquee.pause();
                this.playing = false;
            }
        }
    }

    initClaimsAnimation () {
        this.marquee = nodeMarquee({
            parent: this.$claimsWrapper,
            speed: 2,
            autoplay: false
        });
    }
}

export { ProductClaims };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$productClaims = $context.querySelectorAll('[data-productclaims="root"]');
        for (let i = 0; i < $$productClaims.length; i++) {
            const $productClaims = $$productClaims[i];

            const ProductClaimsAPI = new ProductClaims($productClaims);
            $productClaims.API = ProductClaimsAPI;
        }
    }
});
